




































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import DepressionMixin from '../DepressionMixin'

export default mixins(DepressionMixin).extend({
  props: {
    letter: {
      required: true,
      type: Number,
    },
  },
})
